/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Upgradeto1Inputs */

const zh_subscription_upgradeto1 = /** @type {(inputs: Subscription_Upgradeto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`升级到`)
};

const en_subscription_upgradeto1 = /** @type {(inputs: Subscription_Upgradeto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade to`)
};

const es_subscription_upgradeto1 = /** @type {(inputs: Subscription_Upgradeto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar a`)
};

/**
* | output |
* | --- |
* | "Upgrade to" |
*
* @param {Subscription_Upgradeto1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const subscription_upgradeto1 = /** @type {((inputs?: Subscription_Upgradeto1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Upgradeto1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_subscription_upgradeto1(inputs)
	if (locale === "en") return en_subscription_upgradeto1(inputs)
	return es_subscription_upgradeto1(inputs)
});
export { subscription_upgradeto1 as "subscription_upgradeTo" }